export default __webpack_public_path__ + "static/media/play_white.0d68b3e5.png";